export const TYPE = {
  module: "Module",
};